/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  SearchPatientRequest,
  SearchPatientResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    SearchPatientRequestFromJSON,
    SearchPatientRequestToJSON,
    SearchPatientResponseFromJSON,
    SearchPatientResponseToJSON,
} from '../models/index';

export interface SearchPatientOperationRequest {
    searchPatientRequest: SearchPatientRequest;
    search?: string;
}

/**
 * 
 */
export class PatientSearchApi extends runtime.BaseAPI {

    /**
     * Search Patient
     */
    async searchPatientRaw(requestParameters: SearchPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SearchPatientResponse>>> {
        if (requestParameters['searchPatientRequest'] == null) {
            throw new runtime.RequiredError(
                'searchPatientRequest',
                'Required parameter "searchPatientRequest" was null or undefined when calling searchPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPatientRequestToJSON(requestParameters['searchPatientRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchPatientResponseFromJSON));
    }

    /**
     * Search Patient
     */
    async searchPatient(requestParameters: SearchPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SearchPatientResponse>> {
        const response = await this.searchPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
